// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Belize */
const BZ = /^(?:6[0-35-7]\d{5})$/;

export default BZ;
